import React, { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useAuth } from '~/context/AuthContext';

const AuthCallbackHandler: React.FC = () => {
  const { handleAuthCallback } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const getAuthToken = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (code) {
        // Get the stored redirect URI from session storage
        const redirectUri = sessionStorage.getItem('oauth_redirect_uri');
        if (redirectUri) {
          // Process the authentication code
          await handleAuthCallback(code, redirectUri);
        }
      } else if (error) {
        console.error('Authentication error:', error);

        // Redirect to auth page on error
        window.location.href = '/auth';
      }
    };

    getAuthToken();
  }, [searchParams, handleAuthCallback]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">Processing authentication...</h1>
        <p>Please wait while we complete the sign-in process.</p>
      </div>
    </div>
  );
};

export default AuthCallbackHandler;
